// src/components/CustomerDialog.jsx
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid } from '@mui/material';

function CustomerDialog({ open, onClose, onSave, initialCustomer }) {
  // ### THÊM MỚI ###: State mặc định có thêm businessCode và representativePersonalId
  const [customer, setCustomer] = useState({
    code: '',
    businessCode: '',                 // Mã số kinh doanh (MỚI)
    name: '',
    representative: '',
    position: '',
    representativePersonalId: '',     // CMND/CCCD người đại diện (MỚI)
    address: '',
    phone: '',
    email: '',
    note: ''
  });

  useEffect(() => {
    if (open) {
      if (initialCustomer) {
        // Giữ nguyên dữ liệu cũ, đảm bảo có field mới (tránh undefined)
        setCustomer({
          code: initialCustomer.code || '',
          businessCode: initialCustomer.businessCode || '',
          name: initialCustomer.name || '',
          representative: initialCustomer.representative || '',
          position: initialCustomer.position || initialCustomer.representativePosition || initialCustomer.chucVu || '',
          representativePersonalId: initialCustomer.representativePersonalId || '',
          address: initialCustomer.address || '',
          phone: initialCustomer.phone || '',
          email: initialCustomer.email || '',
          note: initialCustomer.note || ''
        });
      } else {
        // Reset đầy đủ các trường khi tạo mới
        setCustomer({
          code: '',
          businessCode: '',
          name: '',
          representative: '',
          position: '',
          representativePersonalId: '',
          address: '',
          phone: '',
          email: '',
          note: ''
        });
      }
    }
  }, [open, initialCustomer]);

  const handleChange = (e) => setCustomer(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = () => {
    if (!customer.name) { alert('Vui lòng nhập Tên khách hàng/công ty.'); return; }
    // Lưu cả 2 trường mới vào Firestore
    onSave({
      ...customer,
      position: customer.position || '', // đảm bảo có position
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialCustomer ? 'Chỉnh sửa Khách Hàng' : 'Tạo Khách Hàng Mới'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {/* Tên và MST */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="name"
              label="Tên khách hàng/công ty (*)"
              fullWidth
              value={customer.name}
              onChange={handleChange}
              autoFocus
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="code"
              label="Mã số thuế (MST)"
              fullWidth
              value={customer.code}
              onChange={handleChange}
            />
          </Grid>

          {/* Mã số kinh doanh (MỚI) */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="businessCode"
              label="Mã số kinh doanh"
              fullWidth
              value={customer.businessCode}
              onChange={handleChange}
            />
          </Grid>

          {/* Người đại diện + Chức vụ */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="representative"
              label="Người đại diện"
              fullWidth
              value={customer.representative}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="position"
              label="Chức vụ (người đại diện)"
              fullWidth
              value={customer.position}
              onChange={handleChange}
            />
          </Grid>

          {/* CMND/CCCD người đại diện (MỚI) */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="representativePersonalId"
              label="Thông tin cá nhân (CMND/CCCD) người đại diện"
              fullWidth
              value={customer.representativePersonalId}
              onChange={handleChange}
            />
          </Grid>

          {/* Liên hệ */}
          <Grid item xs={12} sm={6}>
            <TextField
              name="phone"
              label="Số điện thoại"
              fullWidth
              value={customer.phone}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              label="Email"
              fullWidth
              value={customer.email}
              onChange={handleChange}
            />
          </Grid>

          {/* Địa chỉ */}
          <Grid item xs={12}>
            <TextField
              name="address"
              label="Địa chỉ"
              fullWidth
              value={customer.address}
              onChange={handleChange}
            />
          </Grid>

          {/* Ghi chú */}
          <Grid item xs={12}>
            <TextField
              name="note"
              label="Ghi chú"
              fullWidth
              multiline
              rows={3}
              value={customer.note}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button onClick={handleSave} variant="contained">Lưu</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CustomerDialog;
